import {
    SET_REASON_CODE, SET_REQUISITION_REASON_CODE,
} from "./ReasonCodeType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_REASON_CODE:
            return {
                ...state,
                reasonCodeList: action.codeList,
            };
        case SET_REQUISITION_REASON_CODE:
            return {
                ...state,
                requisitionReasonCodeList: action.codeList,
            };
        default:
            return state;
    }
};

export default reducer;
